import { renderPage } from "renderPage"
import { WidgetShowPage } from "./Page"
import { TranslatorProvider } from "components/Translator"
import { RouterProvider } from "components/Router"

const App = ({ component: Component, locale, ...props }) => {
  return (
    <TranslatorProvider locale={locale}>
      <RouterProvider>
        <Component {...props} />
      </RouterProvider>
    </TranslatorProvider>
  )
}

renderPage({ component: WidgetShowPage, wrapper: App })
